<template>
    <div class="container mt-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
       <div> <h3 class="mb-0">Group Users  <small class="text-muted" style=" font-size: 14px;">[{{ groupname }} (#{{ groupId }})]</small></h3>
        </div>
        <div class="d-flex align-items-center gap-2 flex-nowrap" style="overflow:auto; white-space: nowrap;">
          <input
            v-model.trim="q"
            @keyup.enter="reload()"
            type="search"
            class="form-control"
            placeholder="ค้นหาผู้ใช้ (กด Enter)"
            style="max-width: 260px;min-width: 200px;"
          />
          <select v-model.number="size" class="form-select" style="width: 120px;">
            <option :value="10">10 / หน้า</option>
            <option :value="20">20 / หน้า</option>
            <option :value="50">50 / หน้า</option>
          </select>
            <button class="btn btn-outline-primary" :disabled="loading" @click="reload()">
                {{ loading ? 'กำลังโหลด...' : 'รีเฟรช' }}
            </button>
           <!-- Add -->
            <div style="max-width: 200px; min-width: 110px;">
                <button class="btn btn-success"  :disabled="loading" @click="openAddModal">
                   <!-- //addUser -->
            + Add User 
            </button>
            </div>
            
             <!-- ✅ Add User แบบบรรทัดเดียว -->
            <div class="input-group" style="max-width: 320px; min-width: 260px;display: none;">
            <input
                v-model.trim="newUserId"
                type="text"
                class="form-control"
                placeholder="User ID"
                :disabled="loading"
            />
            <button
                class="btn btn-success"
                :disabled="loading || !newUserId"
                @click="addUserInline"
            >
                Add
            </button>
            </div>
        </div>
      </div>
  
      <div v-if="error" class="alert alert-danger py-2">
        {{ error }}
      </div>
  
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th style="width: 64px;">#</th>
              <th>Username</th>
              <th>Email</th>
              <th style="width: 140px;">Role</th>
              <th style="width: 180px;">Created At</th>
              <th style="width:120px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="6" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
            </tr>
  
            <tr v-else-if="users.length === 0">
              <td colspan="6" class="text-center text-muted py-4">ไม่พบข้อมูล</td>
            </tr>
  
            <tr v-else v-for="(user, idx) in users" :key="user.id ?? idx">
              <td>{{ (page - 1) * size + idx + 1 }}</td>
              <td>{{ user.username ?? '-' }}</td>
              <td>{{ user.email ?? '-' }}</td>
              <td>{{ user.role ?? '-' }}</td>
              <td>{{ formatDate(user.createdAt) }}</td>
              <td>
                <button class="btn btn-sm btn-outline-danger" :disabled="loading"
                        @click="removeUser(user.id)">
                    Remove
                </button>
               </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center mt-2">
        <div class="text-muted">
          ทั้งหมด: {{ meta.total ?? 0 }} รายการ
        </div>
        <div class="btn-group">
          <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
          <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
          <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
        </div>
      </div>
    </div>

    <!-- Add User Modal -->
    <Transition name="modal-fade-zoom">
  <div v-if="showAddModal" class="mc-backdrop" @click.self="closeAddModal">
    <div class="mc-card" role="dialog" aria-modal="true" aria-labelledby="addUserTitle">
      <div class="mc-header">
        <h5 id="addUserTitle" class="mb-0">เพิ่มผู้ใช้เข้ากลุ่ม</h5>
        <button class="mc-close" @click="closeAddModal" aria-label="Close"></button>
      </div>

      <div class="mc-toolbar">
        <div class="input-group">
          <span class="input-group-text">
            <i class="bi bi-search"></i>
          </span>
          <input
            v-model.trim="qAll"
            @keyup.enter="reloadAllUsers"
            type="search"
            class="form-control"
            placeholder="ค้นหาผู้ใช้ทั้งหมด (กด Enter)"
          />
        </div>

        <div class="d-flex align-items-center gap-2">
          <select v-model.number="sizeAll" class="form-select form-select-sm" style="width: 120px;">
            <option :value="10">10 / หน้า</option>
            <option :value="20">20 / หน้า</option>
            <option :value="50">50 / หน้า</option>
          </select>

          <button class="btn btn-primary btn-sm" :disabled="loadingAll" @click="reloadAllUsers">
            <span v-if="loadingAll" class="spinner-border spinner-border-sm me-1"></span>
            ค้นหา
          </button>
        </div>
      </div>

      <div class="mc-body">
        <div v-if="errorAll" class="alert alert-danger py-2 mb-2">{{ errorAll }}</div>

        <div class="table-responsive mc-table-wrap">
          <table class="table table-hover align-middle">
            <thead class="table-light mc-thead-sticky">
              <tr>
                <th style="width:64px;">#</th>
                <th>Username</th>
                <th>Email</th>
                <th style="width:120px;">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingAll">
                <td colspan="4" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
              </tr>
              <tr v-else-if="allUsers.length === 0">
                <td colspan="4" class="text-center text-muted py-4">ไม่พบผู้ใช้</td>
              </tr>
              <tr v-else v-for="(u, idx) in allUsers" :key="u.id ?? idx">
                <td>{{ (pageAll - 1) * sizeAll + idx + 1 }}</td>
                <td class="fw-600">{{ u.username ?? '-' }}</td>
                <td class="text-muted">{{ u.email ?? '-' }}</td>
                <td>
                  <button
                    class="btn btn-sm"
                    :class="isAlreadyInGroup(u.id) ? 'btn-outline-secondary' : 'btn-success'"
                    :disabled="loadingAll || isAlreadyInGroup(u.id)"
                    @click="addUserById(u.id)"
                  >
                    {{ isAlreadyInGroup(u.id) ? 'Added' : 'Add' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mc-footer">
        <div class="text-muted">ทั้งหมด: {{ metaAll.total ?? 0 }} รายการ</div>
        <div class="btn-group">
          <button class="btn btn-outline-secondary btn-sm" :disabled="pageAll <= 1 || loadingAll" @click="prevPageAll">ก่อนหน้า</button>
          <span class="btn btn-outline-secondary btn-sm disabled">หน้า {{ pageAll }}</span>
          <button class="btn btn-outline-secondary btn-sm" :disabled="disableNextAll || loadingAll" @click="nextPageAll">ถัดไป</button>
        </div>
        <button class="btn btn-secondary btn-sm ms-auto" @click="closeAddModal">ปิด</button>
      </div>
    </div>
  </div>
</Transition>
  </template>
  
  <script setup>
  import { ref, onMounted,onBeforeUnmount, watch, computed } from "vue";
  import { useRoute, useRouter } from "vue-router";
  
  const route = useRoute();
  const router = useRouter();
  const rawname = route.params.name || "";
  const groupId = route.params.id;
  const groupname = ref(decodeURIComponent(rawname));
  const API_URL = process.env.VUE_APP_API_URL
  const loading = ref(false);
  const error = ref("");
  const users = ref([]);
  const meta = ref({ total: 0 });
  
  const q = ref("");
  const page = ref(1);
  const size = ref(10);
  // เพิ่ม state สำหรับช่องกรอก
const newUserId = ref("");

// เพิ่มฟังก์ชัน add แบบ inline
async function addUserInline() {
  if (!newUserId.value) return;
  try {
    loading.value = true;
    await apiPost(`${API_URL}/groups/${groupId}/users`, { userId: newUserId.value });
    newUserId.value = "";
    await load();
    alert("เพิ่มผู้ใช้เข้ากลุ่มสำเร็จ");
  } catch (e) {
    alert("เพิ่มผู้ใช้ไม่สำเร็จ: " + (e?.message || ""));
  } finally {
    loading.value = false;
  }
}
  const disableNext = computed(() => {
    const total = meta.value?.total ?? 0;
    return page.value * size.value >= total;
  });
  
  function getToken() {
    return localStorage.getItem("accessToken");
  }
  
  function authHeaders(json = true) {
  const token = getToken();
  const h = json ? { "Content-Type": "application/json" } : {};
  return token ? { ...h, Authorization: `Bearer ${token}` } : h;
}
function handle401() {
  localStorage.removeItem("accessToken");
  router.push("/login");
}
  
  function formatDate(dt) {
    if (!dt) return "-";
    try {
      const d = new Date(dt);
      if (isNaN(d)) return String(dt);
      return d.toLocaleString();
    } catch {
      return String(dt);
    }
  }
  
  async function apiFetch(url) {
    const res = await fetch(url, { headers: authHeaders() });
    if (res.status === 401) {
      localStorage.removeItem("accessToken");
      router.push("/login");
      throw new Error("Unauthorized");
    }
    if (!res.ok) {
      const t = await res.text().catch(() => "");
      throw new Error(t || `HTTP ${res.status}`);
    }
    return res.json();
  }
//   async function apiGet(url) {
//     const res = await fetch(url, { headers: authHeaders(false) });
//     if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
//     if (!res.ok) throw new Error(await res.text().catch(() => `HTTP ${res.status}`));
//     return res.json();
//   }
    async function apiPost(url, body) {
    const res = await fetch(url, { method: "POST", headers: authHeaders(true), body: JSON.stringify(body) });
    if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
    if (!res.ok) throw new Error(await res.text().catch(() => `HTTP ${res.status}`));
    return res.json();
    }
    async function apiDelete(url) {
    const res = await fetch(url, { method: "DELETE", headers: authHeaders(false) });
    if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
    if (!res.ok) throw new Error(await res.text().catch(() => `HTTP ${res.status}`));
    return res.json().catch(() => ({}));
    }
  async function load() {
    if (!API_URL) {
      error.value = "ไม่พบค่า VUE_APP_API_URL / VITE_API_URL";
      return;
    }
    loading.value = true;
    error.value = "";
    try {
      const query = new URLSearchParams({
        ...(q.value ? { q: q.value } : {}),
        page: String(page.value),
        size: String(size.value),
      });
      const url = `${API_URL}/api/group/${groupId}/users?` + query.toString();
      const json = await apiFetch(url);
  
      users.value = Array.isArray(json?.data) ? json.data : [];
      meta.value = json?.meta ?? { total: users.value.length };
    } catch (e) {
      error.value = e?.message ?? "โหลดข้อมูลล้มเหลว";
    } finally {
      loading.value = false;
    }
  }
  
  function reload() {
    page.value = 1;
    load();
  }
  function nextPage() {
    if (!disableNext.value) {
      page.value += 1;
      load();
    }
  }
  function prevPage() {
    if (page.value > 1) {
      page.value -= 1;
      load();
    }
  }
//   async function addUser() {
//   const userId = window.prompt("ใส่ User ID ที่ต้องการเพิ่มเข้ากลุ่ม:");
//   if (!userId) return;
//   try {
//     loading.value = true;
//     await apiPost(`${API_URL}/api/group/${groupId}/user`, { userId });
//     await load();
//     alert("เพิ่มผู้ใช้เข้ากลุ่มสำเร็จ");
//   } catch (e) {
//     alert("เพิ่มผู้ใช้ไม่สำเร็จ: " + (e?.message || ""));
//   } finally {
//     loading.value = false;
//   }
// }

// === Modal states ===
const showAddModal = ref(false);
const allUsers = ref([]);
const metaAll = ref({ total: 0 });
const loadingAll = ref(false);
const errorAll = ref("");

// ค้นหา/เพจจิ้งใน modal
const qAll = ref("");
const pageAll = ref(1);
const sizeAll = ref(10);

const disableNextAll = computed(() => {
  const total = metaAll.value?.total ?? 0;
  return pageAll.value * sizeAll.value >= total;
});

// set ไว้กัน Add ซ้ำ (ผู้ใช้ที่อยู่ในกลุ่มแล้ว)
const existingUserIds = computed(() => new Set(users.value.map(u => u.id)));
function isAlreadyInGroup(userId){
  return existingUserIds.value.has(userId);
}

function openAddModal(){
  showAddModal.value = true;
  // โหลดหน้าแรกทุกครั้งที่เปิด (หรือคงค่าเดิมได้ตามต้องการ)
  pageAll.value = 1;
  loadAllUsers();
}
function closeAddModal(){
  showAddModal.value = false;
}

function onEsc(e){
  if (e.key === "Escape" && showAddModal.value) closeAddModal();
}
onMounted(() => window.addEventListener("keydown", onEsc));
onBeforeUnmount(() => window.removeEventListener("keydown", onEsc));

async function loadAllUsers(){
  if (!API_URL) { errorAll.value = "ไม่พบค่า VUE_APP_API_URL / VITE_API_URL"; return; }
  loadingAll.value = true; errorAll.value = "";
  try{
    // const query = new URLSearchParams({
    //   ...(qAll.value ? { q: qAll.value } : {}),
    //   page: String(pageAll.value),
    //   size: String(sizeAll.value),
    // });
    const res = await fetch(`${API_URL}/api/users/all` , { headers: authHeaders(false) });
    if (res.status === 401) { handle401(); throw new Error("Unauthorized"); }
    if (!res.ok) throw new Error(await res.text().catch(()=>`HTTP ${res.status}`));
    const json = await res.json();
    allUsers.value = Array.isArray(json?.data) ? json.data : [];
    metaAll.value = json?.meta ?? { total: allUsers.value.length };
  }catch(e){
    errorAll.value = e?.message ?? "โหลดผู้ใช้ทั้งหมดล้มเหลว";
  }finally{
    loadingAll.value = false;
  }
}

function reloadAllUsers(){
  pageAll.value = 1;
  loadAllUsers();
}
function nextPageAll(){ if (!disableNextAll.value){ pageAll.value += 1; loadAllUsers(); } }
function prevPageAll(){ if (pageAll.value > 1){ pageAll.value -= 1; loadAllUsers(); } }

// เพิ่มผู้ใช้ (กด Add ที่แถวใน modal)
async function addUserById(userId){
  if (!userId) return;
  try{
    loadingAll.value = true;
    await apiPost(`${API_URL}/api/group/${groupId}/user`, { userId });
    // รีโหลดทั้ง modal list (เผื่ออยากให้ปุ่มเปลี่ยนเป็น Added) และตารางหลัก
    await Promise.all([loadAllUsers(), load()]);
    // แจ้งเตือนสั้น ๆ (เอา alert ออกได้ถ้าไม่ชอบเด้ง)
    alert("เพิ่มผู้ใช้เข้ากลุ่มสำเร็จ");
  }catch(e){
    alert("เพิ่มผู้ใช้ไม่สำเร็จ: " + (e?.message || ""));
  }finally{
    loadingAll.value = false;
  }
}

async function removeUser(userId) {
  if (!window.confirm("ยืนยันลบผู้ใช้ออกจากกลุ่ม?")) return;
  try {
    loading.value = true;
    await apiDelete(`${API_URL}/api/group/${groupId}/user/${userId}`);
    await load();
    alert("นำผู้ใช้ออกจากกลุ่มสำเร็จ");
  } catch (e) {
    alert("ลบไม่สำเร็จ: " + (e?.message || ""));
  } finally {
    loading.value = false;
  }
}
  onMounted(load);
  watch([() => route.params.id], load);
  watch(size, reload);
  </script>
  
  <style scoped>
 .table td,.table th{ vertical-align: middle; }

/* ===== Modern Clean Modal ===== */
.mc-backdrop{
  position: fixed; inset: 0; z-index: 1060;
  display:flex; align-items:center; justify-content:center;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
}

.mc-card{
  width: min(920px, 95vw);
  max-height: min(80vh, 880px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0,0,0,.08), 0 30px 60px rgba(0,0,0,.12);
  overflow: hidden;
  display:flex; flex-direction:column;
}

.mc-header{
  position: sticky; top: 0;
  display:flex; align-items:center; justify-content:space-between;
  gap: 12px; padding: 14px 16px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(#ffffff, #fafbfc);
}
.mc-toolbar{
  display:flex; align-items:center; justify-content:space-between;
  gap: 12px; padding: 12px 16px;
  border-bottom: 1px solid #f0f3f8; background: #fff;
}
.mc-body{ padding: 0 16px 12px 16px; overflow: hidden; }
.mc-footer{
  position: sticky; bottom: 0;
  display:flex; align-items:center; gap: 12px;
  padding: 10px 16px; border-top: 1px solid #eef2f7;
  background: linear-gradient(#fafbfc, #ffffff);
}

/* Close button */
.mc-close{
  width: 32px; height: 32px; border: 0; border-radius: 8px;
  background: transparent; position: relative; opacity: .7;
}
.mc-close:hover{ opacity: 1; background: #f5f6f8; }
.mc-close::before, .mc-close::after{
  content:""; position:absolute; left:9px; right:9px; top:15px;
  height:2px; background:#64748b;
}
.mc-close::before{ transform: rotate(45deg); }
.mc-close::after{ transform: rotate(-45deg); }  /* ← แก้ . ขาด */

.mc-table-wrap{
  max-height: 52vh;
  overflow:auto; border: 1px solid #eef2f7; border-radius: 12px;
}
.mc-thead-sticky th{
  position: sticky; top: 0; z-index: 1;
  background: #f8fafc !important;
  border-bottom: 1px solid #e9eef5 !important;
}
.fw-600{ font-weight: 600; }

/* Transition */
.modal-fade-zoom-enter-active,
.modal-fade-zoom-leave-active{ transition: all .18s ease; }
.modal-fade-zoom-enter-from,
.modal-fade-zoom-leave-to{ opacity:0; transform: translateY(6px) scale(.98); }
  </style>